var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportFavouritesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24C13.88 24 13.75 23.97 13.64 23.9C12.76 23.34 9.65003 21.28 6.65003 18.39C4.90003 16.69 3.50003 15.02 2.49003 13.4C1.22003 11.37 0.550032 9.42 0.510032 7.59C0.510032 7.52 0.510032 7.45 0.510032 7.39C0.500032 3.31 3.81003 0 7.88003 0C10.35 0 12.64 1.24 14 3.25C15.36 1.24 17.65 0 20.12 0C24.19 0 27.5 3.31 27.5 7.38C27.5 7.45 27.5 7.51 27.5 7.58C27.45 9.41 26.79 11.37 25.52 13.4C24.51 15.02 23.11 16.69 21.35 18.38C18.35 21.27 15.24 23.33 14.36 23.89C14.25 23.96 14.12 24 14 24ZM7.88003 1.33C4.54003 1.33 1.82003 4.05 1.82003 7.39C1.82003 7.45 1.82003 7.51 1.82003 7.56C2.00003 14.23 11.72 21.04 14 22.54C16.28 21.04 26 14.22 26.17 7.55C26.17 7.49 26.17 7.44 26.17 7.38C26.17 4.04 23.45 1.32 20.11 1.32C17.74 1.32 15.58 2.71 14.6 4.87C14.5 5.11 14.26 5.26 14 5.26C13.74 5.26 13.5 5.11 13.4 4.87C12.42 2.72 10.25 1.33 7.88003 1.33Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportFavouritesBlack);
export default __webpack_public_path__ + "static/media/icons-2_export-FAVOURITES-BLACK.8bc4f4fbc8cf3d235fc5cd159b5c03a7.svg";
export { ForwardRef as ReactComponent };